import React from 'react';
import { ArrowDown, ArrowUp } from 'react-feather';
import styled from 'styled-components';

const Label = styled.span.attrs((props) => {
  console.log('props.overview (inside attrs):', props?.overview);
})`
  padding: 2px 12px;
  text-align: center;
  border-radius: 5px;
  font-size: 10px;
  color: #fff;
 
  width: ${props => {
    if (props.width) {
      return props.width;
    }
    else {
      return '90px';
    }
  }};
  display: inline-block;
  white-space: nowrap;
  background-color: ${props => {
    if (props.color) {
      return props.color;
    }
    
    if (props.status == 0) {
      return 'var(--color-new-secondary)';
    }
    const commonStyles = `
    padding: 2px 10px; 
    text-align: center;
    border-radius: 5px;

    
  `;
  
  const colors = {
    initiated: 'var(--color-new-orange)',
    canceled: '#FF0000',
    requested: '#fa5c7c',
    incoming: 'var(--color-new-secondary)',
    outgoing: '#fa5c7c',
    other: 'var(--color-new-orange)',
    done: 'var(--color-new-secondary)',
  };


  
  if (['initiated', 'requested', 'incoming', 'outgoing', 'other', 'done', 'canceled'].includes(props.status)) {
    return {
      styles: commonStyles,
      backgroundColor: colors[props.status] || 'black', // Default to black if undefined
    };
  }
    if (props.status == 1) {
      return '#fa5c7c';
    }
    if (props.status == 2) {
      return 'var(--color-new-orange)';
    }
    if (props.status == 3) {
      return '#727cf5';
    }
    if (props.status == 4) {
      return 'var(--color-new-black)';
    }
    if (props.status == 5) {
      return '#5871D3';
    }
    if (props.status == 6) {
      return '#FF0000';
    }
    if (props.status == 7) {
      return '#00bfae';
    }
    if (props.status == 8) {
      return '#5871D3';
    }
    if (props.status == 9) {
      return 'orange';
    }

    return 'var(--color-new-secondary)';
  }};
`;

export const VehicleStatusLabel = ({ children, status, onClick, color, width, overview, plannable, className }) => {
  const displayedText = overview === 'double' && typeof children === 'string' ? children.charAt(0) : children;


  return (
    <>
      {overview === 'double' && status == 'incoming' ? (
       <span style={{ color: 'green' }}> <ArrowDown /></span>
      ) : 
        overview === 'double' && status == 'outgoing' ? (
          <span style={{ color: 'red' }}> <ArrowUp /> </span>
        ) : (
        <Label
          className={className}
          onClick={onClick}
          status={status}
          width={width}
          overview={overview}
          color={plannable ? 'var(--color-new-secondary)' : color}
        >
          {displayedText}
        </Label>
      )}
    </>
  );
};

